// extracted by mini-css-extract-plugin
export default {"spinner":"fileModal_spinner__7CyGs","download":"fileModal_download__hbXkX"};